import React from 'react';
import { AppRouter } from './routing/app-router';

export const app = () => {
  return (
        <AppRouter/>
  );
}
export default app;
